import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleContainer, InputLabel, Input, TextArea, Message } from '@weezevent/nacre';
import { isUrl } from '../../utils';
import css from '../../styles.module.css';

export default function EmailToggle({ form, setForm, messageIsValid, setMessageIsValid, premiumOptions, isEmailingBlocked }) {
    const { t } = useTranslation();

    const handleToggle = React.useCallback((e, { checked }) => {
        setForm('send_mail', checked);
    }, []);

    const handleObject = React.useCallback(e => {
        setForm('mail_subject', e.target.value || null);
    }, []);

    const handleMessage = React.useCallback(
        e => {
            setForm('mail_body', e.target.value || null);
            if (!premiumOptions) {
                const words = e.target.value.split(/\s+/);
                if (words.some(w => isUrl(w))) {
                    setMessageIsValid(false);
                } else {
                    setMessageIsValid(true);
                }
            }
        },
        [premiumOptions]
    );

    return (
        <>
            <Message title={t('attendees.invitations.outbound_emails_blocked_title')} type="default" visible={isEmailingBlocked}>
                {t('attendees.invitations.outbound_emails_blocked_label')}
            </Message>
            <ToggleContainer
                className={css['email-title-position']}
                title={t('attendees.invitations.toggle')}
                onChange={handleToggle}
                checked={form.send_mail}
                disabled={isEmailingBlocked}
            />
            {form.send_mail && (
                <div className={css['email-optional-section']}>
                    <div className={css['optional-inputs']}>
                        <InputLabel label={t('attendees.invitations.message.labels.subject')} />
                        <Input placeholder={t('attendees.invitations.message.subject')} onChange={handleObject} value={form.mail_subject} />
                    </div>
                    <div className={css['optional-inputs']}>
                        <InputLabel label={t('attendees.invitations.message.labels.body')} />
                        {!messageIsValid && <Message title={t('attendees.invitations.premium_url_not_allowed')} type="danger" visible />}
                        <TextArea
                            className={`${css['email-textarea']} ${messageIsValid ? css['valid'] : css['invalid']}`}
                            onChange={handleMessage}
                            value={form.mail_body}
                            placeholder={t('attendees.invitations.message.subject')}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
